import script from "./PersonOfTheYear.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonOfTheYear.vue?vue&type=script&setup=true&lang=js"

import "./PersonOfTheYear.vue?vue&type=style&index=0&id=275568a5&lang=css"

export default script